import { FLAG_NAMES, flagIsEnabled } from "lib/environment";

export const pkceIsEnabled = () => {
  const LOCAL_MODE = import.meta.env.VITE_APP_MSW_ENABLED === "true";
  return flagIsEnabled(FLAG_NAMES.ENABLE_PKCE) && !LOCAL_MODE;
};
